<template>
  <v-select
    :items="allowedYears"
    v-model="selected"
    label="Año"
    dense
    outlined
    hide-details
    class="ml-4"
    style="max-width:120px"
    @change="onYearChange"
  />
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "YearPicker",

  computed: {
    // 🔥 Tomamos los años permitidos directamente del store
    ...mapGetters(["availableYears"]),

    // Alias para simplificar el template
    allowedYears() {
      return this.availableYears;
    },

    // Año actual global desde Vuex
    selectedYearFromStore() {
      return this.$store.state.selectedYear;
    },
  },

  data() {
    return {
      // El valor inicial viene desde Vuex
      selected: this.$store.state.selectedYear,
    };
  },

  watch: {
    // Si el año global cambia desde fuera, actualiza el select
    selectedYearFromStore(newVal) {
      this.selected = newVal;
    }
  },

  methods: {
    ...mapActions(["hydrateProducersByYear"]),

    onYearChange() {
      console.log("📅 Cambio de año detectado en YearPicker:", this.selected);

      // 1) Actualizar globalmente el año seleccionado
      this.$store.commit("setSelectedYear", this.selected);

      // 2) Rehidratar productores para ese año
      this.hydrateProducersByYear(this.selected);

      // 3) Notificar a Home.vue / Dashboard.vue
      this.$emit("year-changed", this.selected);
    }
  }
};
</script>
